import * as moment from 'moment';
import { LayoutService } from './../../layout/layout.service';
import {
  EventType,
  RecordLine,
  RecordModel,
} from './../../layout/record-model';
import { ModuleStructure, FieldDataType } from './../module-structure';
import * as g from '../../globals';
import * as serviceCall from './ServiceCall';
export class GlobalObject {
  constructor() {}
  static ObjectLoad(
    recordModel: RecordModel,
    moduleStructure: ModuleStructure,
    layoutService: LayoutService
  ) {
    recordModel.Categories.forEach((cat) => {
      const section = moduleStructure.module.Sections.find(
        (sec) => sec.XmlTagName === cat.Id
      );
      cat.Lines.forEach((recordLine) => {
        for (const property of recordLine.Properties) {
          if (
            property.ExecuteParentChangeOnLoad &&
            recordModel.EventType !== EventType.View
          ) {
            const field = section.Fields.find(
              (p) => p.PropertyName === property.Name
            );
            if (
              field.ParentProperties != null &&
              field.ParentProperties !== ''
            ) {
              let queryIdToExecute = field.SQLStatementParentChanged;
              if (queryIdToExecute == null || queryIdToExecute === 0) {
                queryIdToExecute = field.SQLStatementId;
              }

              if (queryIdToExecute != null && queryIdToExecute !== 0) {
                layoutService.getFieldValueOnParentChange(
                  recordModel,
                  cat,
                  recordLine,
                  property,
                  queryIdToExecute,
                  field,
                  moduleStructure,
                  false
                );
              }
            }
          }
        }
      });
    });

    layoutService.triggerObjectLoad({
      recordModel: recordModel,
      moduleStructure: moduleStructure,
    });
  }

  static FillDataOnExternalCreate(
    recordModel: RecordModel,
    moduleStructure: ModuleStructure,
    layoutService: LayoutService
  ) {
    const documentCat = recordModel.Categories.find(
      (cat) => cat.Id === 'Documents'
    );
    if (documentCat == null || documentCat === undefined) {
      return;
    }
    const recordLine = documentCat.Lines[0];
    if (recordLine == null || recordLine === undefined) {
      return;
    }
    const cardCodeProp = recordLine.Properties.find(
      (prop) => prop.Name === 'CardCode'
    );
    if (cardCodeProp == null || cardCodeProp === undefined) {
      return;
    }

    const field = moduleStructure.module.Sections.find(
      (sec) => sec.XmlTagName === 'Documents'
    ).Fields.find((f) => f.PropertyName === 'CardCode');

    this.loadSelectedRecord(
      recordModel,
      moduleStructure,
      layoutService,
      '2',
      cardCodeProp.ValueAsObject,
      recordLine,
      'Documents',
      field
    );
  }

  static loadSelectedRecord(
    recordModel: RecordModel,
    moduleStructure: ModuleStructure,
    layoutService: LayoutService,
    linkedModule,
    selectedValue,
    recordLine: RecordLine,
    sectionTagName: string,
    argField: import('src/app/models/module-structure').Field,
    validateClicked: boolean = false
  ) {
    const linkField = !validateClicked ? '' : (argField.LinkedField ?? '');
    layoutService
      .getModuleHeaderData(linkedModule, selectedValue, linkField, false)
      .subscribe((d) => {
        if (recordModel.ObjectCode === '191') {
          serviceCall.setModuleHeaderData(d);
        }
        moduleStructure.module.Sections.forEach((section) => {
          if (section.XmlTagName === sectionTagName) {
            section.Fields.forEach((field) => {
              if (
                field.LinkedModule === argField.LinkedModule &&
                argField.LinkedModuleGroup === field.LinkedModuleGroup
              ) {
                const linkedFieldStr = this.getLinkedModuleField(
                  linkedModule,
                  field.LinkedField
                );

                // const value = d[field.LinkedField];
                let value = d[linkedFieldStr];

                recordLine.Properties.forEach((property) => {
                  if (property.Name === field.PropertyName) {
                    if (property.DataType === FieldDataType.Select) {
                      const option = property.Options?.find(
                        (op) => op.Code === value || op.DBValue === value
                      );
                      if (option != null && option !== undefined) {
                        value = option.Code.toString();
                      }
                    } else if (property.DataType === FieldDataType.Date) {
                      value = moment(
                        value,
                        g.companyConfiguration.MomentDateFormat
                      ).toDate();
                    }
                    property.ValueAsObject = value;
                    layoutService.triggerFieldValueChanged({
                      recordProperty: property,
                      formId: '',
                      line: recordLine.Id,
                      recordModel,
                      sectionTagName,
                      moduleStructure,
                    });
                  }
                });
              }
            });
          }
        });
      });
  }

  static getLinkedModuleField(
    linkedModuleId: string,
    linkedField: string
  ): string {
    if (
      linkedField == null ||
      linkedField === undefined ||
      linkedField === ''
    ) {
      return '';
    }
    if (linkedField.indexOf('{"') !== 0) {
      return linkedField;
    }
    const obj = JSON.parse(linkedField);

    for (const k in obj) {
      if (obj.hasOwnProperty(k)) {
        if (k === linkedModuleId) {
          return obj[k];
        }
      }
    }

    return linkedField;
  }
}
